import _ from 'lodash';

function GameDetailCtrl($rootScope, $q, $scope, $state, $stateParams, $timeout, toastr, PlanService, UserService, AppContextService) {
  'ngInject';

  var vm = this;
  vm.appContext = AppContextService.context;
  var isLoaded = false;

  //#region init
  vm.gname_id = '';
  vm.gtype_id = '';
  vm.lawn_id = '';
  vm.stadium_id = '';
  vm.appContext.oppoTeam_id = '';
  // vm.appContext.players.game.my_team.entryMain = [];
  vm.appContext.players.game.my_team.entryBackup = [];
  vm.appContext.players.game.oppo_team.entryMain = [];
  vm.appContext.players.game.oppo_team.entryBackup = [];
  // // TODO : test purpose
  // if (!$stateParams.game_id) {
  //   vm.gname_id = 3;
  //   vm.gtype_id = 1;
  //   vm.lawn_id = 1;
  //   vm.stadium_id = 4;
  //   vm.appContext.oppoTeam_id = 72;
  //   vm.appContext.players.game.my_team.entryMain = [{ "entry_id": 3344, "user_id": 1881, "position_id": 2, "position_name": "DF", "team_id": 20, "team_name": "FC서울", "back_number": "40", "image_url": "", "name": "김원균" }];
  //   vm.appContext.players.game.my_team.entryBackup = [{ "user_id": "1875", "login_id": "", "name": "김한길", "ename": "KIM HANGIL", "image_url": "", "position": "MF", "age": "23", "height": 178, "status": "정상훈련", "back_number": "32", "rank": "?", "$$hashKey": "object:198", "position_name": "MF" }];
  //   vm.appContext.players.game.oppo_team.entryMain = [{
  //     "user_id": "1381", "login_id": "", "name": " Jaloliddin Masharipov", "ename": " Jaloliddin Masharipov", "image_url": "", "gender": "M", "min1": "", "min2": "", "min3": "", "phone1": "", "phone2": "", "phone3": "", "address": "", "birth_date": "19930901", "back_number": "22", "parent_country_id": 1, "country_id": "33", "country_name": "우즈베키스탄"
  //   }];
  //   vm.appContext.players.game.oppo_team.entryBackup = [{
  //     "user_id": "1377", "login_id": "", "name": "Djavokhir Sokhibov", "ename": "Djavokhir Sokhibov", "image_url": "", "gender": "M", "min1": "", "min2": "", "min3": "", "phone1": "", "phone2": "", "phone3": "", "address": "", "birth_date": "19950301", "back_number": "18", "parent_country_id": 1, "country_id": "33", "country_name": "우즈베키스탄"
  //   }];
  // }
  
  //#endregion

  var date, time;
  

  var setDateTime = function (d) {
    var tzoffset = (new Date(d)).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(new Date(d) - tzoffset)).toISOString().slice(0, -5);
    date = localISOTime.split("T")[0].split("-").join(".");
    time = localISOTime.split("T")[1];
  }

  if (!vm.dateTime) {
    vm.dateTime = new Date();
    setDateTime(vm.dateTime);
  }

  vm.dateTimeChanged = function (dateTime) {
    setDateTime(dateTime._d);
  }

  vm.startGame2 = function () {

    //#region input verification
    if (!date) {
      toastr.error('날짜가 지정되어 있지 않습니다.');
      return;
    }

    if (!time) {
      toastr.error('시간이 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.appContext.players.game.my_team.entryMain.length) {
      toastr.error('우리팀 주전선수가 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.appContext.players.game.my_team.entryBackup.length) {
      toastr.error('우리팀 후보선수가 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.appContext.players.game.oppo_team.entryMain.length) {
      toastr.error('상대팀 주전선수가 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.appContext.players.game.oppo_team.entryBackup.length) {
      toastr.error('상대팀 후보선수가 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.appContext.oppoTeam_id) {
      toastr.error('상대팀 id가 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.gtype_id) {
      toastr.error('경기타입이 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.gname_id) {
      toastr.error('경기이름이 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.stadium_id) {
      toastr.error('경기장이 지정되어 있지 않습니다.');
      return;
    }

    if (!vm.lawn_id) {
      toastr.error('경기장 잔디상태가 지정되어 있지 않습니다.');
      return;
    }
    //#endregion

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: date,
      time: time
    };

    PlanService.setGame(data)
      .then(function (res) {
        delete data.date;
        delete data.time;
        data.game_id = res.data.game_id;
        $stateParams.game_id = res.data.game_id;
        data.gtype_id = vm.gtype_id;
        data.gname_id = vm.gname_id;
        data.team_id = vm.appContext.oppoTeam_id;
        data.stadium_id = vm.stadium_id;
        data.lawn_id = vm.lawn_id;
        return PlanService.setGameInfo(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        data.user_id = _.map(vm.appContext.players.game.my_team.entryMain, 'user_id').join();
        data.status = 'IN'; // IN, WAIT, OUT(교체됨)
        data.is_oppo = 'N';

        return PlanService.setEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        data.user_id = _.map(vm.appContext.players.game.my_team.entryBackup, 'user_id').join();
        data.status = 'WAIT'; // IN, WAIT, OUT(교체됨)
        data.is_oppo = 'N';

        return PlanService.setEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        data.user_id = _.map(vm.appContext.players.game.oppo_team.entryMain, 'user_id').join();
        data.status = 'IN'; // IN, WAIT, OUT(교체됨)
        data.is_oppo = 'Y';

        return PlanService.setEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        data.user_id = _.map(vm.appContext.players.game.oppo_team.entryBackup, 'user_id').join();
        data.status = 'WAIT'; // IN, WAIT, OUT(교체됨)
        data.is_oppo = 'Y';

        return PlanService.setEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        // $state.go('Service.gameRecord', { game_id: game_id, year: $stateParams.year, month: $stateParams.month });
        $state.go('Service.game', { year: $stateParams.year, month: $stateParams.month });
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
  }

  vm.setGame = function() {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: date,
      time: time
    };

    PlanService.setGame(data)
      .then(function (res) {
        $stateParams.game_id = res.data.game_id;
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
  }
  

  var getGameInfo = function () {

    if (!$stateParams.game_id) {
      return;
    }
    var dataGetGameInfo = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.game_id,
    }

    PlanService.getGameInfo(dataGetGameInfo)
      .then(function (res) {
        vm.gameInfo = res.data;
      });


    dataGetGameInfo.parent_id = 1;

    PlanService.getGameInfo(dataGetGameInfo)
      .then(function (res) {
        vm.gameInfo = res.data;
      });

  };
  getGameInfo();

  var getEntry = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.game_id,
      status: 'IN',
      is_oppo: 'N'
    }

    PlanService.getEntry(data)
      .then(function (res) {
        vm.appContext.players.game.my_team.entryMain = res.data.players;
        data.status = 'WAIT';
        data.is_oppo = 'N';
        return PlanService.getEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        vm.appContext.players.game.my_team.entryBackup = res.data.players;
        data.status = 'IN';
        data.is_oppo = 'Y';
        return PlanService.getEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        vm.appContext.players.game.oppo_team.entryMain = res.data.players;
        data.status = 'WAIT';
        data.is_oppo = 'Y';
        return PlanService.getEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        vm.appContext.players.game.oppo_team.entryBackup = res.data.players;
        isLoaded = true;
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })


  };

  if ($stateParams.game_id) {
    getEntry();
  }

  vm.remove = function (game_id) {
    ///plan/remove_game
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: game_id
    }
    PlanService.removeGame(data).then(function () {
      $state.go('Service.game', { year: $stateParams.year, month: $stateParams.month });
    })
  }

  vm.setGameInfo = function (key, value) {

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.game_id,
      [key]: value,
      // first_end: '13:45:00',
    }
    PlanService.setGameInfo(data).then(function () {
      getGameInfo();
    })

  }


  PlanService.getGameMeta()
    .then(function (res) {
      vm.gtypes = res.data.gtypes;
      vm.lawns = res.data.lawns;
    })


  PlanService.getGnames()
    .then(function (res) {
      vm.parentGnames = res.data.list;
    })

  // 기존선수를 삭제(OUT)한 후, 추가(IN)한다.
  var setEntry = function (is_oppo, oldVal, newVal) {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.game_id,
      user_id: _.map(oldVal, 'user_id').join(),
      status: 'OUT',
      is_oppo: is_oppo
    };

    PlanService.setEntry(data)
      .then(function (res) {
        data.user_id = _.map(newVal, 'user_id').join();
        data.status = 'IN'
        return PlanService.setEntry(data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })


  }

  $scope.$watch('gameDetail.appContext.players.game.my_team.entryMain', function (newVal, oldVal) {
    if (newVal && isLoaded) {

      // console.log('game.ourTeam.entryMain', oldVal, newVal);
      setEntry('N', oldVal, newVal);

    }
  });


  $scope.$watch('gameDetail.parent_gname_id', function (newVal, oldVal) {
    if (newVal) {
      PlanService.getGnames({ parent_id: newVal }).then(function (res) {
        vm.gnames = res.data.list;
      }).catch(function (e) {
        console.log('ERROR', e);
      });
    }
  });

  // var dataGetStadiums = {};
  PlanService.getStadiums()
    .then(function (res) {
      vm.parentStadiums = res.data.list;
    })


  vm.openModal = function (type, team) {
    // console.log(type,team);
    vm.appContext.type = type;
    vm.appContext.team = team;
  }

  $scope.$watch('gameDetail.parent_stadium_id', function (newVal, oldVal) {
    if (newVal) {
      PlanService.getStadiums({ parent_id: newVal }).then(function (res) {
        vm.stadiums = res.data.list;
        vm.getWeather();
      }).catch(function (e) {
        console.log('ERROR', e);
      });
    }
  });

  vm.gameInfoData = {};

  vm.getWeather = function () {
    // const address = vm.selectedStadium1.name + ' ' + vm.selectedStadium2.name;

    var address = '강원 강릉제일고등학교'
    let lat;
    let lng;
    // 지오코딩
    PlanService.geocode(address).then(function (data) {
      if (data.results && data.results.length) {
        lat = data.results[0].geometry.location.lat;
        lng = data.results[0].geometry.location.lng;

        let gridObj = PlanService.dfsXyConv('toXY', lat, lng);

        // 기상청 날씨정보 가져오기
        PlanService.getWeather(gridObj.nx, gridObj.ny).then(function (data) {
          let items = data.response.body.items.item;

          // 하늘상태(날씨)
          let sky = _.find(items, {
            category: 'SKY'
          });

          if (sky) {
            if (sky.obsrValue == 1) {
              vm.gameInfoData.weather = '맑음';
            } else if (sky.obsrValue == 2) {
              vm.gameInfoData.weather = '구름조금';
            } else if (sky.obsrValue == 3) {
              vm.gameInfoData.weather = '구름많음';
            } else if (sky.obsrValue == 4) {
              vm.gameInfoData.weather = '흐림';
            }
          }

          // 습도
          let reh = _.find(items, {
            category: 'REH'
          });
          if (reh) {
            vm.gameInfoData.humidity = reh.obsrValue;
          }

          // 기온
          let t1h = _.find(items, {
            category: 'T1H'
          });
          if (t1h) {
            vm.gameInfoData.temperature = t1h.obsrValue;
          }

          // 풍속(바람)
          let wsd = _.find(items, {
            category: 'WSD'
          });
          if (wsd) {
            vm.gameInfoData.wind = wsd.obsrValue;
          }
        });

        // 미세먼지 정보 가져오기
        // PlanService.getFineDust(vm.selectedStadium1.name).then(function(data) {
        PlanService.getFineDust('강원').then(function (data) {
          let findDustData = data.list[0];

          vm.gameInfoData.pm10 = findDustData.pm10Value;
          vm.gameInfoData.pm25 = findDustData.pm25Value;
        });
      }
    });
  };






  vm.startGame1 = function () {

    var dataSetGame = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: date,
      time: time
    }


    PlanService.setGame(dataSetGame)
      .then(function (res) {
        var d = $q.defer();

        var dataSetEntry = {
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid,
          game_id: res.data.game_id,
          // user_id: _.map(vm.appContext.players.game.my_team.entryMain, 'user_id').join(),
          user_id: '1881', //'1859,1884,1880', //
          status: 'IN', // IN, WAIT, OUT(교체됨)
          is_oppo: 'N'
        }
        d.resolve(dataSetEntry);
        return d.promise;

      })
      .then(function (dataSetEntry) {
        PlanService.setEntry(dataSetEntry).then(function (res) {
          // $state.go('Service.gameRecord', { game_id: dataSetEntry.game_id, year: $stateParams.year, month: $stateParams.month });
        });
      });

  }

  vm.startGame2 = function () {

    var dataSetGame = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: date,
      time: time
    }

    var game_id;

    PlanService.setGame(dataSetGame)
      .then(function (res) {
        game_id = res.data.game_id;
        var dataSetEntry = {
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid,
          game_id: game_id,
          user_id: _.map(vm.appContext.players.game.my_team.entryMain, 'user_id').join(),
          status: 'IN', // IN, WAIT, OUT(교체됨)
          is_oppo: 'N'
        }
        return PlanService.setEntry(dataSetEntry);
      })
      .then(function (res) {
        $state.go('Service.gameRecord', { game_id: game_id, year: $stateParams.year, month: $stateParams.month });
      });

  }
















  // vm.gtype_id = 1;


  // vm.videos = [
  //   { title: '박지성맨유경기', player: '박지성', url: 'https://www.youtube.com/watch?v=aSIkQ8USdWc', img: 'https://img.youtube.com/vi/zUfSyc7Nsd4/0.jpg' },
  //   { title: '박지성맨유경기2', player: '박지성', url: 'https://youtu.be/aSIkQ8USdWc', img: 'https://img.youtube.com/vi/zUfSyc7Nsd4/0.jpg' },
  // ]
  // // 썸네일 이미지 추출
  // _.forEach(vm.videos, function (video) {
  //   if (video.url.indexOf('?v=') > -1) {
  //     video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
  //   } else {
  //     video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
  //   }
  // });













  // vm.gameMetaData = {};


  // // 경기 정보 입력에 필요한 데이터 조회
  // PlanService.getGameMeta().then(function (res) {
  //   var data = res.data;
  //   vm.gameMetaData.gtypes = data.gtypes;
  //   vm.gameMetaData.lawns = data.lawns;

  //   // if (!vm.gameInfoData.game_id) {
  //   //   vm.gameInfoData.gtype = data.gtypes[0];
  //   //   vm.gameInfoData.lawn = data.lawns[0];
  //   // } else {
  //   //   let gtypeIdx = vm.gameInfoData.gtype_id;
  //   //   let lawnIdx = vm.gameInfoData.lawn_id;

  //   //   vm.gameInfoData.gtype = { id: vm.gameInfoData.gtype_id, name: vm.gameInfoData.gtype_name };
  //   //   vm.gameInfoData.lawn = { id: vm.gameInfoData.lawn_id, name: vm.gameInfoData.lawn_name };
  //   // }
  // }).catch(function (e) {
  //   console.log('ERROR', e);
  // });

  // // 초기 경기장 목록 불러오기
  // vm.stadiums1 = null;
  // vm.selectedStadium1 = null;
  // vm.stadiums2 = null;
  // vm.selectedStadium2 = null;
  // PlanService.getStadiums().then(function (res) {
  //   var data = res.data;
  //   vm.stadiums1 = data.list;
  //   // if (!vm.gameInfoData.game_id) {
  //   //   vm.selectedStadium1 = vm.stadiums1[0];
  //   //   if (vm.stadiums1[0].is_last) {
  //   //     vm.gameInfoData.stadium_id = vm.stadiums1[0].id;
  //   //   }
  //   // } else {
  //   //   let idx = _.findIndex(
  //   //     vm.stadiums1,
  //   //     {
  //   //       'id': vm.gameInfoData.parent_stadium_id
  //   //     }
  //   //   );
  //   //   vm.selectedStadium1 = vm.stadiums1[idx];
  //   // }
  // }).catch(function (e) {
  //   console.log('ERROR', e);
  // });

  // // 초기 경기 명칭 목록 불러오기
  // vm.parentGnames = null;
  // vm.selectedParentGname = null;
  // vm.gnames = null;
  // vm.selectedGname = null;
  // PlanService.getGnames().then(function (data) {
  //   vm.parentGnames = data.list;
  //   // vm.selectedParentGname = vm.parentGnames[0];
  // }).catch(function (e) {
  //   console.log('ERROR', e);
  // });

  // //   // 초기 대륙 목록 불러오기
  // //   vm.continents = null; // 대륙 목록
  // //   vm.selectedContinent = null;
  // //   vm.selectedCountry = null;
  // //   UserService.getCountries().then(function(data) {
  // //     vm.continents = data.list;
  // //     if(vm.oppPlayers){
  // //       vm.selectedContinent = vm.selectedOppTeam.continent;
  // //     }else{
  // //       vm.selectedContinent = vm.continents[0];
  // //     }
  // //   });

  // //   // 초기 팀 목록 불러오기
  // //   PlanService.getTeams().then(function(data) {
  // //     console.log('vm.gameInfoData : ', vm.gameInfoData)
  // //     vm.teams1 = data.list;
  // //     if(!vm.gameInfoData.game_id){
  // //       vm.selectedTeam1 = vm.teams1[0];
  // //     }else{
  // //       let idx = _.findIndex(
  // //                               vm.teams1,
  // //                               {
  // //                                 'id': vm.gameInfoData.parent_team_id
  // //                               }
  // //                             );
  // //       vm.selectedTeam1 = vm.teams1[idx];
  // //     }
  // //   });
  // // }

  // // 경기 명칭 1단계 변경
  // $scope.$watch('recordGame.selectedParentGname', function (newVal, oldVal) {
  //   if (newVal) {
  //     PlanService.getGnames({ parent_id: newVal.id }).then(function (res) {
  //       var data = res.data;
  //       vm.gnames = data.list;
  //       // vm.selectedGname = vm.gnames[0];
  //     // $scope.$apply(function () {
  //     //     vm.gnames = data.list;
  //     //     vm.selectedGname = vm.gnames[0];
  //     //   });
  //     }).catch(function (e) {
  //       console.log('ERROR', e);
  //     });
  //   }
  // });

  // // 경기 명칭 2단계 변경
  // $scope.$watch('recordGame.selectedGname', function (newVal, oldVal) {
  //   if (newVal) {
  //     vm.gameInfoData.gname_id = newVal.id;
  //   }
  // });

  // // // 대륙 변경
  // // $scope.$watch('recordGame.selectedContinent', function(newVal, oldVal) {
  // //   if (newVal && !newVal.is_last) {
  // //     UserService.getCountries({ parent_id: newVal.id }).then(function(data) {
  // //       console.log('countires : ', data);
  // //       $scope.$apply(function() {
  // //         vm.countries = data.list;
  // //         if(vm.oppPlayers){
  // //           vm.selectedCountry = vm.selectedOppTeam.country;
  // //         }else{
  // //           vm.selectedCountry = vm.countries[0];
  // //         }
  // //       });
  // //     });
  // //   }
  // // });

  // // // 국가 변경
  // // $scope.$watch('recordGame.selectedTeamCountry', function(newVal, oldVal) {
  // //   if (newVal) {
  // //     // 초기 팀 목록 불러오기
  // //     UserService.getTeams({ country_id: newVal.id }).then(function(data) {
  // //       $scope.$apply(function() {
  // //         vm.teams1 = data.list;
  // //         if(vm.oppPlayers){
  // //           vm.selectedTeam1 = vm.selectedOppTeam.selectedTeam1;
  // //         }else{
  // //           vm.selectedTeam1 = vm.teams1[0];
  // //         }
  // //       });
  // //     });
  // //   }
  // // });

  // // // 팀 1단계 변경
  // // $scope.$watch('recordGame.selectedTeam1', function(newVal, oldVal) {
  // //   if (newVal && !newVal.is_last) {
  // //     UserService.getTeams({ parent_id: newVal.id }).then(function(data) {
  // //       $scope.$apply(function() {
  // //         vm.teams2 = data.list;
  // //         if(vm.oppPlayers){
  // //           vm.selectedTeam2 = vm.selectedOppTeam.selectedTeam2;
  // //         }else{
  // //           vm.selectedTeam2 = vm.teams2[0];
  // //         }
  // //       });
  // //     });
  // //   } else {
  // //     if (newVal) {
  // //       vm.gameInfoData.team_id = newVal.id;
  // //       vm.opp_team_name = newVal.name;
  // //     }
  // //     vm.teams2 = null;
  // //     vm.teams3 = null;
  // //   }
  // // });

  // // // 팀 2단계 변경
  // // $scope.$watch('recordGame.selectedTeam2', function(newVal, oldVal) {
  // //   vm.selectedTeam3 = null;
  // //   vm.selectedTeam4 = null;

  // //   if (newVal && !newVal.is_last) {
  // //     UserService.getTeams({ parent_id: newVal.id }).then(function(data) {
  // //       $scope.$apply(function() {
  // //         vm.teams3 = data.list;
  // //         if(vm.oppPlayers){
  // //           vm.selectedTeam3 = vm.selectedOppTeam.selectedTeam3;
  // //         }else{
  // //           vm.selectedTeam3 = vm.teams3[0];
  // //         }
  // //       });
  // //     });
  // //   } else {
  // //     if (newVal) {
  // //       vm.gameInfoData.team_id = newVal.id;
  // //       vm.opp_team_name = newVal.name;
  // //     }
  // //     vm.teams3 = null;
  // //   }
  // // });

  // // // 팀 3단계 변경
  // // $scope.$watch('recordGame.selectedTeam3', function(newVal, oldVal){
  // //   console.log(newVal);
  // //   if (newVal && !newVal.is_last) {
  // //     UserService.getTeams({ parent_id: newVal.id }).then(function(data) {
  // //       $scope.$apply(function() {
  // //         vm.teams4 = data.list;
  // //         if(vm.oppPlayers){
  // //           vm.selectedTeam4 = vm.selectedOppTeam.selectedTeam4;
  // //         }else{
  // //           vm.selectedTeam4 = vm.teams4[0];
  // //         }
  // //       });
  // //     });
  // //   } else {
  // //     if (newVal) {
  // //       vm.gameInfoData.team_id = newVal.id;
  // //       vm.opp_team_name = newVal.name;
  // //     }
  // //     vm.teams4 = null;
  // //   }
  // // });

  // // // 팀 4단계 변경
  // // $scope.$watch('recordGame.selectedTeam4', function(newVal, oldVal) {
  // //   if (newVal) {
  // //     vm.gameInfoData.team_id = newVal.id;
  // //     vm.opp_team_name = newVal.name;
  // //   }
  // // });
  // // /**
  // //  * select 변경시 값 적용
  // //  */
  // // // 경기상황 - 구분 변경
  // // $scope.$watch('recordGame.gameInfoData.gtype', function(newVal, oldVal) {
  // //   if (newVal) {
  // //     vm.gameInfoData.gtype_id = newVal.id;
  // //   }
  // // });

  // // // 경기상황 - 잔디 변경
  // // $scope.$watch('recordGame.gameInfoData.lawn', function(newVal, oldVal) {
  // //   if (newVal) {
  // //     vm.gameInfoData.lawn_id = newVal.id;
  // //   }
  // // });

  // // // 경기장 1단계 변경
  // // $scope.$watch('recordGame.selectedStadium1', function(newVal, oldVal) {
  // //   if (newVal && !newVal.is_last) {
  // //     PlanService.getStadiums({ parent_id: newVal.id }).then(function(data) {
  // //       $scope.$apply(function() {
  // //         vm.stadiums2 = data.list;
  // //         if(!vm.gameInfoData.game_id){
  // //           vm.selectedStadium2 = vm.stadiums2[0];
  // //         }else{
  // //           let idx = _.findIndex(
  // //                                   vm.stadiums2,
  // //                                   {
  // //                                     'id': vm.gameInfoData.stadium_id
  // //                                   }
  // //                                 );
  // //           vm.selectedStadium2 = vm.stadiums2[idx];
  // //         }
  // //       });
  // //     });
  // //   }
  // // });

  // // // 경기장 2단계 변경
  // // $scope.$watch('recordGame.selectedStadium2', function(newVal, oldVal) {
  // //   if (newVal) {
  // //     vm.gameInfoData.stadium_id = newVal.id;

  // //     // 날씨 정보 불러오기
  // //     vm.getWeather();
  // //   }
  // // });

  // // /**
  // //  * 동작 기능
  // //  */
  // // // 날씨 정보 불러오기
  // // vm.getWeather = function() {
  // //   const address = vm.selectedStadium1.name + ' ' + vm.selectedStadium2.name;
  // //   let lat;
  // //   let lng;
  // //   // 지오코딩
  // //   console.log('address **** ',address);
  // //   PlanService.geocode(address).then(function(data) {
  // //     if (data.results && data.results.length) {
  // //       lat = data.results[0].geometry.location.lat;
  // //       lng = data.results[0].geometry.location.lng;

  // //       let gridObj = PlanService.dfsXyConv('toXY', lat, lng);

  // //       // 기상청 날씨정보 가져오기
  // //       PlanService.getWeather(gridObj.nx, gridObj.ny).then(function(data) {
  // //         let items = data.response.body.items.item;

  // //         // 하늘상태(날씨)
  // //         let sky = _.find(items, {
  // //           category: 'SKY'
  // //         });

  // //         if (sky) {
  // //           if (sky.obsrValue == 1) {
  // //             vm.gameInfoData.weather = '맑음';
  // //           } else if (sky.obsrValue == 2) {
  // //             vm.gameInfoData.weather = '구름조금';
  // //           } else if (sky.obsrValue == 3) {
  // //             vm.gameInfoData.weather = '구름많음';
  // //           } else if (sky.obsrValue == 4) {
  // //             vm.gameInfoData.weather = '흐림';
  // //           }
  // //         }

  // //         // 습도
  // //         let reh = _.find(items, {
  // //           category: 'REH'
  // //         });
  // //         if (reh) {
  // //           vm.gameInfoData.humidity = reh.obsrValue;
  // //         }

  // //         // 기온
  // //         let t1h = _.find(items, {
  // //           category: 'T1H'
  // //         });
  // //         if (t1h) {
  // //           vm.gameInfoData.temperature = t1h.obsrValue;
  // //         }

  // //         // 풍속(바람)
  // //         let wsd = _.find(items, {
  // //           category: 'WSD'
  // //         });
  // //         if (wsd) {
  // //           vm.gameInfoData.wind = wsd.obsrValue;
  // //         }
  // //       });

  // //       // 미세먼지 정보 가져오기
  // //       PlanService.getFineDust(vm.selectedStadium1.name).then(function(data) {
  // //         let findDustData = data.list[0];

  // //         vm.gameInfoData.pm10 = findDustData.pm10Value;
  // //         vm.gameInfoData.pm25 = findDustData.pm25Value;
  // //       });
  // //     }
  // //   });
  // // };

  // // vm.setGameInfoResult = function() {
  // //   if (!vm.gameInfoData.game_id) {
  // //     toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  // //     return;
  // //   }
  // //   $scope.$parent.base.setGameInfo();
  // //   // $scope.$parent.base.setGameResult();
  // // };

  // // // 동영상 생성/수정
  // // vm.setMurl = function() {
  // //   if (!vm.gameInfoData.game_id) {
  // //     toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  // //     return;
  // //   }

  // //   if (!vm.setMurlData.url) {
  // //     toastr.error('동영상 URL을 입력해주십시오');
  // //     return;
  // //   }

  // //   if(!vm.setMurlData.title) {
  // //     toastr.error('동영상 제목을 입력해주십시오');
  // //     return;
  // //   }

  // //   // 유튜브 동영상의 경우 동영상 url 변경
  // //   // 예) https://www.youtube.com/watch?v=aSIkQ8USdWc => https://www.youtube.com/embed/aSIkQ8USdWc
  // //   if (vm.setMurlData.url.match('youtube.com')) {
  // //     if (!vm.setMurlData.url.match('\/embed\/')) {   // 이미 embed URL 인 경우 제외
  // //       let urlId = vm.setMurlData.url.split('=')[1];
  // //       vm.setMurlData.url = 'https://www.youtube.com/embed/' + urlId;
  // //     }
  // //   } else if (vm.setMurlData.url.match('youtu.be')) {  // 예) https://youtu.be/aSIkQ8USdWc
  // //     let urlSplitLen = vm.setMurlData.url.split('/').length;
  // //     let urlId = vm.setMurlData.url.split('/')[urlSplitLen - 1];
  // //     vm.setMurlData.url = 'https://www.youtube.com/embed/' + urlId;
  // //   }

  // //   let setMurlData = angular.copy(vm.setMurlData);
  // //   setMurlData.training_id = null;
  // //   PlanService.setMurl(setMurlData).then(function(data) {
  // //     if (data.murl_id) {
  // //       toastr.success('저장되었습니다.')
  // //       vm.setMurlData.title = null;
  // //       vm.setMurlData.url = null;
  // //       $scope.$parent.base.getGameResult();
  // //     }
  // //   });
  // // };

  // // //동영상 삭제
  // // vm.viewMediaId = '';
  // // vm.removeMurl = function(id) {
  // //   vm.removeMurlData.murl_id = id;
  // //   PlanService.removeMurl(vm.removeMurlData).then(function(data) {
  // //     if(data.result == 'SUC'){
  // //       toastr.success('삭제되었습니다.')
  // //       vm.setMurlData.title = null;
  // //       vm.setMurlData.url = null;
  // //       if(vm.viewMediaId == id){
  // //         let el = angular.element("#viewMedia");
  // //         el.attr('src', '');
  // //       }
  // //       $scope.$parent.base.getGameResult();
  // //     }
  // //   });
  // // }

  // // vm.displayMedia = function(id, url){
  // //   // vm.viewMedia = 'https://www.youtube.com/watch?v=ADq3QLntd5Y';
  // //   vm.viewMediaId = id;
  // //   let el = angular.element("#viewMedia");
  // //   el.attr('src', url);
  // // }





}

export default {
  name: 'GameDetailCtrl',
  fn: GameDetailCtrl
};
